import { render, staticRenderFns } from "./RrcvD_Receive.vue?vue&type=template&id=dc72698a"
import script from "./RrcvD_Receive.vue?vue&type=script&lang=js"
export * from "./RrcvD_Receive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports